import gql from 'graphql-tag'

export default gql`
  mutation createPayment(
    $cartInfo: CartInfo!
    $stctype: String!
    $sessionData: SessionData
  ) {
    createPayment(
      cartInfo: $cartInfo
      stctype: $stctype
      sessionData: $sessionData
    ) {
      ecToken
    }
  }
`
